<template>
  <div v-if="expatriateData.remarkList">
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="left flex-between">
                <div
                  class="title-control flex-between"
                  @click="showHandleData = !showHandleData"
                >
                  <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "Remark" : "备注" }}
                </p>
                <span></span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="right flex-between">
                <el-button
                  style="width: 150px; margin-right: 16px"
                  type="primary"
                  size="mini"
                  @click="addRemark = true"
                  >{{ $lange == "en" ? "Add Remark" : "添加备注" }}</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
        <el-collapse-transition>
          <div class="li_wrap" v-if="showHandleData">
            <div
              class="null_remark"
              v-if="expatriateData.remarkList.length == 0"
            >
              无数据
            </div>
            <div
              class="li"
              v-for="(li, index) in expatriateData.remarkList"
              :key="index"
            >
              <!-- 手动添加备注 | -->
              <el-alert type="info" :closable="false" v-if="li.objType == 0">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">{{ "添加备注" }}</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div>{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>

              <!-- 修改外派工单明细||  向客户推送方案   -->
              <el-alert
                type="info"
                :closable="false"
                v-if="li.objType == 1 || li.objType == 2"
              >
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">
                      {{ li.objType == 1 ? "修改外派工单明细" : "推送客户" }}
                    </h3>
                  </div>
                </template>
                <template>
                  <div
                    class="remark_wrap"
                    v-if="li.extraData && li.extraData.expatriatePlanList"
                  >
                    <div
                      class="li_data"
                      v-for="(goods, ind) in li.extraData.expatriatePlanList"
                      :key="ind"
                    >
                      <div style="width: 200px" v-if="$lange != 'en'">
                        {{
                          $lange == "en" ? "Engineer Category" : "工程师类别"
                        }}：{{ employeeType[goods.employeeType] }}
                      </div>
                      <div style="width: 250px" v-if="$lange == 'en'">
                        {{
                          $lange == "en" ? "Engineer Category" : "工程师类别"
                        }}：{{ employeeType2[goods.employeeType] }}
                      </div>
                      <div
                        :style="
                          $lange == 'en' ? 'width: 250px' : 'width: 100px'
                        "
                      >
                        {{ $lange == "en" ? "Number of engineer" : "人数" }}：{{
                          goods.num
                        }}
                      </div>
                      <div :style="
                          $lange == 'en' ? 'width: 250px' : 'width: 120px'
                        ">
                        {{
                          $lange == "en"
                            ? "Estimated Working Hours"
                            : "预计总工时"
                        }}：{{ goods.preWorkHour }}
                      </div>
                      <div style="width: 130px" v-if="$lange != 'en'">
                        {{ $lange == "en" ? "Cost Type" : "费用类型" }}：{{
                          feeType[li.extraData.feeType]
                        }}
                      </div>
                      <div style="width: 130px" v-if="$lange == 'en'">
                        {{ $lange == "en" ? "Cost Type" : "费用类型" }}：{{
                          feeType2[li.extraData.feeType]
                        }}
                      </div>
                    </div>
                    <div class="time">
                      <span :style="$lange == 'en' ? 'width: 250px' : 'width: 200px'">{{ $lange == 'en' ? 'Scheduled to start' : '计划开始时间'}}：{{ getTime(li.extraData.startTime) }}</span>
                      {{ $lange == 'en' ? 'Scheduled to finish' : '计划结束时间'}}：{{ getTime(li.extraData.endTime) }}
                    </div>
                    <div></div>
                  </div>
                </template>
              </el-alert>

              <!-- 向客户推送最终报告及费用  ||修改最终报告及费用 -->
              <el-alert
                type="info"
                :closable="false"
                v-if="li.objType == 3 || li.objType == 4"
              >
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">
                      {{
                        li.objType == 3
                          ? "推送最终报告及费用"
                          : "修改最终报告及费用"
                      }}
                    </h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div class="li_data">
                      <div style="width: 200px">
                        {{ $lange == "en" ? "服务费" : "服务费" }}：{{
                          (li.extraData.serviceFee / 100).toFixed(2)
                        }}
                      </div>
                      <div style="width: 200px">
                        {{ $lange == "en" ? "交通费" : "交通费" }}
                        {{ (li.extraData.trafficFee / 100).toFixed(2) }}
                      </div>
                      <div style="width: 200px">
                        {{ $lange == "en" ? "餐宿费" : "餐宿费" }}：{{
                          (li.extraData.accommodationFee / 100).toFixed(2)
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-alert>

              <!--取消 || 客户对最终报告【有异议】  -->
              <el-alert
                type="info"
                :closable="false"
                v-if="li.objType == 6 || li.objType == 7"
              >
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">
                      {{ objType == 6 ? "取消外派訂單" : "对最终报告有异议" }}
                    </h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div>说明：{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>

              <!--取消 || 客户对最终报告【有异议】  -->
              <el-alert type="info" :closable="false" v-if="li.objType == 5">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <!-- <h3 class="title">{{ li.handlerName }}</h3> -->
                    <h3 class="title">客戶对最终报告有异议</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div>说明：{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <el-dialog
      :title="$lange == 'en' ? 'Add remark' : '添加备注'"
      :visible.sync="addRemark"
      width="50%"
      append-to-body
    >
      <el-input
        size="mini"
        type="textarea"
        :rows="4"
        v-model="remarkMsg"
        :placeholder="$lange == 'en' ? 'Please enter remark' : '请输入备注'"
      ></el-input>
      <div class="add_remark_button">
        <el-button type="primary" size="small" @click="saveRemark">{{
          $lange == "en" ? "Submit" : "保存"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    expatriateData: Object,
  },
  data() {
    return {
      showHandleData: true,
      addRemark: false,
      remarkMsg: "",
      feeType: ["保内", "保外"],
      feeType2: ["Free", "Paid"],
      employeeType: ["机械工程师", "电气工程师", "软件工程师", "质量工程师"],
      employeeType2: ["Mechanic", "Electrical", "Software", "Quality"],
    };
  },
  computed: {},
  methods: {
    getTime(e) {
      if (e) {
        return moment(e).format("YYYY-MM-DD");
      }
    },
    saveRemark() {
      let remarkMsg = this.remarkMsg.replace(/(^\s*)|(\s*$)/g, "");
      if (remarkMsg == "") {
        this.$message.error("请输入备注");
        return false;
      }
      let data = {
        remark: this.remarkMsg,
        expatriateOrderId: this.expatriateData.id,
      };
      this.ccRequest
        .do("admin/fsb/expatriate/addRemark", data, "GET")
        .then((res) => {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.remarkMsg = "";
          this.addRemark = false;
          // this.$emit("updateOrder", { code: "remarkList",});
          this.$emit("updateOrder", true);
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.order-solution {
  background: #ffffff;
  // margin-top: 5px;

  .os-list {
    padding: 20px;
    // border-bottom: 1px dotted #ccc;
    border-top: 10px solid #f3f3f4;
    // border-top: 5px solid #f3f3f4;
    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }
  }
}
.li_wrap {
  margin-top: 20px;
  .li {
    margin-bottom: 20px;
  }
}
.remark_wrap {
  font-size: 14px;
  color: #000 !important;
}
.right {
  display: flex;
  justify-content: flex-end;
}
.add_remark_button {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.title_wrap {
  display: flex;
  color: #000;
  padding: 10px 0;
  font-size: 12px !important;
  .title {
    margin-right: 10px;
    // font-size: 18px;
  }
}
.null_remark {
  text-align: center;
  padding: 10px;
  color: #c3c1c1;
}
.li_data {
  display: flex;
  margin-top: 10px;
  // font-size: 16px;
  div {
    margin-right: 20px;
    margin-bottom: 5px;
  }
}
.allPrice {
  margin-top: 10px;
  margin-bottom: 10px;
}
.time {
  display: flex;
  span {
    display: block;
    margin-right: 19px;
  }
}
</style>